import "./styles/App.css";
import logo from "./assets/images/logo-toromacho.png";
import React, { createContext, useState } from "react";

import Ventana_Inicial from "./modules/Ventana_Inicial";
import Ventana_contacto from "./modules/Ventana_contacto";

export const ventanas = createContext();

function App() {
  const [ventana, setVentana] = useState("ventana-inicial");

  function btn_switchVentana({ children }) {
    return <div className="btn-switchVentana">{children}</div>;
  }

  function btn_ventanaInicial() {
    return <div className="btn_ventanaInicial"></div>;
  }

  function barra_navegacion() {
    return (
      <div className="content-barra">
        <img src={logo} className="logo"></img>
        <div className="content-btnNavegacion">
          <div
            className="btn-navegacion btn-inicio"
            onClick={(e) => {
              setVentana("ventana-inicial");
            }}
          >
            Inicio
          </div>
          <div className="btn-navegacion btn-nosotros">Sobre Nosotros</div>
          <div className="btn-navegacion btn-tienda">Tienda</div>
        </div>
      </div>
    );
  }

  function content_ventanas() {
    return <div className="content-ventanas">{render_ventana()}</div>;
  }

  function render_ventana() {
    switch (ventana) {
      case "ventana-inicial":
        return <Ventana_Inicial />;
      case "ventana_contacto":
        return <Ventana_contacto />;
    }
  }

  return (
    <ventanas.Provider value={{ ventana, setVentana }}>
      <div className="App">
        {barra_navegacion()}
        {content_ventanas()}
      </div>
    </ventanas.Provider>
  );
}

export default App;
